var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNotFilesFound = function SvgNotFilesFound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 288,
    viewBox: "0 0 356 288",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "89.38%",
    x2: "50%",
    y1: "-2.106%",
    y2: "85.564%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B4BBCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7D86A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: ".004%",
    x2: "100.004%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "0%",
    y1: "49.988%",
    y2: "49.988%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "0%",
    y1: "50.003%",
    y2: "50.003%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "49.982%",
    x2: "49.982%",
    y1: "99.996%",
    y2: ".012%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "85.716%",
    x2: "-20.309%",
    y1: "48.316%",
    y2: "59.643%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8842C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#501F99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: "85.716%",
    x2: "-20.309%",
    y1: "49.702%",
    y2: "51.704%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8842C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#501F99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: "85.716%",
    x2: "-20.309%",
    y1: "49.702%",
    y2: "51.704%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8842C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#501F99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: "127.42%",
    x2: "13.136%",
    y1: "-9.586%",
    y2: "72.815%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E8EBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#CCD2E0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7D86A1",
    fillRule: "nonzero",
    d: "M181.13 54.178c-9.511 14.825-26.386 19.214-42.719 18.006-16.332-1.208-32.828-7.202-49.246-10.029-13.764-2.37-27.485-2.494-40.688-.379C29.58 64.803 10.274 74.063 3.028 95.535c-8.067 23.92 3.833 58.978 24.542 72.328 10.54 6.794 22.049 8.193 33.075 12.654 11.026 4.46 22.839 13.828 26.308 27.866 3.207 12.982-1.892 25.277-8.394 33.995-5.025 6.735-11.416 14.368-9.184 24.459 2.158 9.76 11.151 15.18 18.856 17.468 25.136 7.465 50.85-.542 67.375-20.981 5.89-7.292 10.669-16.056 17.263-22.346 17.313-16.524 43.012-13.077 65.826-15.915 19.307-2.403 37.597-9.81 53.502-21.663 9.55-7.118 18.52-16.286 22.714-29.516 3.025-9.545 3.359-20.56 3.523-31.385.176-11.542.198-23.12.067-34.734-.082-6.971-.23-14.057-1.835-21.048-2.915-12.671-10.362-23.802-18.6-32.727-19.558-21.196-45.045-32.512-68.218-30.28-23.174 2.23-43.603 17.956-54.724 42.1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7D86A1",
    strokeWidth: 2,
    d: "M163.176 97.282c8.709-3.741 23.08 16.528 39.384 6.535 16.305-9.992 8.098-38.237 19.921-42.88 11.824-4.644 13.934 13.777 33.195 22.02 19.262 8.244 46.255-7.409 61.553 24.882 15.297 32.29-61.594 63.545-26.357 91.537 23.492 18.66 17.285 32.516-18.623 41.566-44.025 9.913-78.204 4.054-102.538-17.578-28.855-23.334-43.305-111.596-6.535-126.082z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.698)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M203.035 59.433c.047-.14.085-.286.123-.433-.12.325-.226.659-.316 1 .066-.192.133-.38.193-.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8B3BA",
    fillRule: "nonzero",
    d: "M190.374 66.935s-1.016 4.605-2.888 5.2c-1.873.596 2.272 5.865 2.272 5.865l8.59-.448.156-1.706s-1.622-3.417 1.094-7.574c2.716-4.158-9.224-1.337-9.224-1.337z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B77983",
    fillRule: "nonzero",
    d: "M176.975 177.978c-.122 1.476-3.808.919-3.808.919-6.115.836-5.105-5.07-5.105-5.07v-.301l.212-5.507.061-1.536s6.734-3.032 6.562-2.395c-.064.239.078.813.273 1.433.337 1.032.818 2.2.818 2.2s.04 2.434-.161 3.151c-.202.717 1.053 2.634 1.053 2.634s0 .12.02.332c.1 1.378.125 2.76.075 4.14zM187.84 178.896s-3.688.56-3.81-.918a37.1 37.1 0 0 1 .064-4.147c0-.199.017-.332.017-.332s1.257-1.916 1.054-2.632c-.202-.716-.161-3.152-.161-3.152s.131-.308.303-.752c.36-.932.903-2.443.791-2.874-.161-.64 6.565 2.39 6.565 2.39l.067 1.717.206 5.32v.302s1.024 5.917-5.096 5.078z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6BAC2",
    fillRule: "nonzero",
    d: "M211.766 36.049c-2.02 6.496-8.153 8.28-8.153 8.28s-4.105 3.044-4.69 3.997c-.584.953-5.63 5.044-6.958 5.58-1.328.538-2.342 1.427-1.986 2.621.318 1.109-3.158 6.534-3.683 7.341l-.063.102-1.097 1.146-3.72 1.884-3.032-.969-.384-3.64 1.608-2.859a7.888 7.888 0 0 0 2.278-2.487c1.045-1.734 1.76-2.929 1.76-2.929s1.147-2.725 2.955-4.332a26.738 26.738 0 0 1 4.026-2.86l7.47-4.446s1.681-1.248 2.86-1.588c1.179-.34 12.824-11.337 10.81-4.841z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M181.666 63.803L187 62.87a.28.28 0 0 0-.095.193l-.069.096-1.176 1.074L181.666 66l-3.253-.908L178 61.68l1.726-2.68c-1.634 2.977-.041 5.091-.041 5.091l1.981-.288zM211 80.29a.911.911 0 0 0-.036.101c-.048.113-.11.22-.187.317l-2.042.975-3.117.317L204 78.165l1.078-4.202.595-.786.165-.177c.062.76.376 4.725.356 5.916-.026 1.32.971 1.425.971 1.425L211 80.29z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F7FA",
    fillRule: "nonzero",
    d: "M210 80.23a.946.946 0 0 0-.035.104c-.154.49-2.104 2.56-2.104 2.56s-5.6 3.851-7.396 4.512c-1.796.66-4.162 4.11-4.162 4.11l-2.363 4.908s-4.236 3.224-4.646 4.088c-.285.586-.262 1.611-.22 2.217 0 .268.038.445.038.445l-1.249 1.312-.996 1.044-1.402 1.47-2.283-.322-7.114-1.138-1.364-.774-7.572-4.293s0-.268-.02-.677c0-.18 0-.387-.019-.616-.022-.696-.054-1.563-.09-2.301-.076-1.525 1.08-4.135 1.08-4.135l2.129-5.277c-.205-1.006.976-3.671.976-3.671-.205-.387 1.028-4.239 1.335-4.6.308-.36.823-3.078.823-3.078.64-.928 1.566-5.66 1.566-5.66s1.053-5.999 1.28-7.497c.228-1.5 2.818-4.858 2.901-4.961-1.847 3.41-.23 5.892-.23 5.892l1.85-.322 5.011-.983c-.23.154-.077 1.86-.077 1.86.444.34.738.84.82 1.395.048.758.96 1.934 1.13 2.144l.026.029a2.524 2.524 0 0 1 1.207-1.734l1.156 1.553.387 1.86s-.105.261-.771.777.281 1.86.281 1.86c.32.544.413 2.559.413 2.559.849-.748 2.18-.748 2.18-.748a6.647 6.647 0 0 0 1.31-1.889.779.779 0 0 1 .428-.528.77.77 0 0 1 .677.013 7.1 7.1 0 0 1 1.258-.88c.618-.323 1.335.322 1.335.322l.077 2.382s.061.097.16.229c.202.283.564.719.791.644.32-.103 2.9.155 2.9.155s.9.387 1.234-.103c.333-.49 2.24-1.782 2.24-1.782s.369 4.799.369 6.14c0 1.34.96 1.45.96 1.45l3.785-.064z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.027 80.07h-.066c.12-.316.066 0 .066 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.5,
    cy: 77.5,
    r: 1,
    fill: "#4B4442",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.5,
    cy: 83.5,
    r: 1,
    fill: "#4B4442",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 98.5,
    r: 1,
    fill: "#4B4442",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.5,
    cy: 90.5,
    r: 1,
    fill: "#4B4442",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M175 165.44c-2.203 2.807-4.582 2.76-6 2.365l.053-1.454s5.86-2.87 5.71-2.268c-.056.226.055.77.237 1.357zM192 170.063c-4.063 2.37-6.446-.408-7-1.194.34-.902.853-2.366.748-2.783-.153-.62 6.201 2.314 6.201 2.314l.051 1.663z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCD2E0",
    fillRule: "nonzero",
    d: "M193.727 164.488c-.791 1.161-.745 4.038-.745 4.038-5.106 3.736-7.782-.809-7.782-.809s.346-2.927-.247-5.25a11.154 11.154 0 0 1-.1-4.596s-.098-4.645-.349-5.3c-.25-.655-.346-2.575-.247-3.283.099-.708-.643-2.32-.643-2.32s0-2.02-.349-2.474c-.35-.453-.742-3.689-.742-3.689l-2.376-9.087s-.992-5.502-1.388-6.714c-.396-1.211-.893-.96-.893-.96l-1.428 6.513-1.091 11.108c-.547 1.259-.31 4.192-.31 4.192l.347 4.29-.575 7.372a.453.453 0 0 0 .18.403 12.336 12.336 0 0 1 .83 7.12c-3.767 5.555-8.328 2.675-8.328 2.675a11.96 11.96 0 0 0-.89-3.683c-.844-2.121.148-10.701.148-10.701l-.745-5.556s-.05-3.333-.198-3.777c-.148-.444-.099-3.736-.099-3.736l.1-3.484c-1.29-4.445-.647-11.46-.647-11.46s-.197-11.21.201-11.716c.288-.365.105-2.027.229-3.226.013-.364.113-.72.29-1.036l.05-.05c.646-.81.646-4.039.593-5.304-.024-.667.424-1.75.85-2.619.31-.61.59-1.114.696-1.297l.043-.072s2.825.708 10.31 4.344c1.34.675 2.778 1.13 4.259 1.344.737.1 1.483.112 2.222.034a7.66 7.66 0 0 0 3.196-1.057c.516-.3.982-.682 1.381-1.13-.102.314-.04 1.391 0 2.033.019.293.04.491.04.491l.826 3.746c.134.444.237.897.309 1.356.058.334.108.696.154 1.08.578 4.79.27 12.864.27 12.864s1.235 11.058.645 11.561c-.59.504-.102 2.222-.102 2.222.449.986.718 2.046.794 3.13-.004.845.201 1.679.597 2.423l-.201 4.998.52 10.844s1.189 3.043.395 4.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M187 146s4.03-1.5 4.91-.825c.878.675-4.91.825-4.91.825zM190.104 148s-.46.391.554.891c1.015.5-.554-.891-.554-.891zM167.004 142.04c-.126.033 3.091 1.888 5.996.352-.012 0-5.272-.542-5.996-.351zM173 145s-1.132 1.724-3.45 1.98c-2.32.255 3.45-1.98 3.45-1.98zM185 150s4.803 7.134 3.883 8.817C187.963 160.5 185 150 185 150zM178.46 108l-.46 13s2.726-.109 3.192-4.392c.466-4.283.808-7.772.808-7.772l-3.54-.836z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B839C",
    fillRule: "nonzero",
    d: "M178.459 108L178 121s2.722-.109 3.187-4.395c.466-4.286.813-7.769.813-7.769l-3.541-.836z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M173 107.408s-2.13 5.542-7 2.858c.013-.354.115-.7.297-1.009 1.333.543 4.422 1.338 5.686-2.257l1.017.408z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M173 107.405s-2.13 5.546-7 2.86c.013-.354.115-.7.297-1.009 1.333.546 4.422 1.338 5.686-2.256l1.017.405z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B839C",
    fillRule: "nonzero",
    d: "M173 107.405s-2.13 5.546-7 2.86c.013-.354.115-.7.297-1.009 1.333.546 4.422 1.338 5.686-2.256l1.017.405z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M191 111.384c-5.122 2.493-7-3.384-7-3.384l1.21.037c.211 3.758 4.26 2.747 5.648 2.286.048.34.097.683.142 1.06z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M191 111.385c-5.12 2.49-7-3.385-7-3.385l1.21.037c.211 3.757 4.26 2.749 5.648 2.288.048.328.097.683.142 1.06z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B839C",
    fillRule: "nonzero",
    d: "M191 111.385c-5.12 2.49-7-3.385-7-3.385l1.21.037c.211 3.76 4.26 2.749 5.648 2.288.048.328.097.683.142 1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M177 177.093c0 .366 0 .708-.04.99-.121 1.324-3.803.824-3.803.824-3.362.414-4.572-1.014-4.972-2.38a4.855 4.855 0 0 1-.185-1.356 4.99 4.99 0 0 1 .06-.815v-.271a2.478 2.478 0 0 1 2.092.378c1.496 1.074 3.48.25 3.48.25s1.455.107 2.017.535c.316.241.837-.34 1.233-.892.024.357.06 1.002.084 1.692.027.354.034.711.034 1.045z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M172 176.736s-1.303.829-3.761-.45A3.466 3.466 0 0 1 168 175c1.255.62 3.583 1.736 4 1.736zM176 176.882a.817.817 0 0 1-.535.11.726.726 0 0 1-.465-.24c.359-.223.689-.475.985-.752.009.3.015.601.015.882zM184 177.091c0 .37 0 .712.038.991.12 1.327 3.802.825 3.802.825 3.361.416 4.572-1.012 4.972-2.381.198-.71.24-1.448.124-2.172v-.271a2.507 2.507 0 0 0-2.094.378c-1.496 1.074-3.476.25-3.476.25s-1.456.11-2.017.538c-.316.241-.837-.339-1.23-.892a54.564 54.564 0 0 0-.088 1.693c-.027.348-.034.705-.03 1.041z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M189 177.736s1.303.83 3.757-.452c.164-.42.245-.851.243-1.284-1.26.618-3.587 1.736-4 1.736zM184 177.882a.817.817 0 0 0 .535.11.725.725 0 0 0 .465-.24 6.19 6.19 0 0 1-.987-.752c-.01.298-.015.599-.012.882zM180 80s-5.689 13.744-3.498 14.937C178.692 96.13 180 80 180 80zM184 76s-1.563 4.564-.781 4.977C184 81.391 184 76 184 76zM194 87s-6.413 5.523-5.979 5.977C188.455 93.431 194 87 194 87zM198 74.812c-2.08.659-6.945 2.2-7 2.188l.27-1.15c.769-.698 1.976-.698 1.976-.698a6.215 6.215 0 0 0 1.187-1.764.723.723 0 0 1 .388-.493.68.68 0 0 1 .613.011c.352-.315.734-.59 1.141-.822.56-.3 1.21.301 1.21.301l.07 2.222s.055.081.145.205z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCD2E0",
    fillOpacity: 0.12,
    fillRule: "nonzero",
    d: "M198 74.813c-2.08.66-6.945 2.202-7 2.187l.27-1.148c.769-.698 1.976-.698 1.976-.698a6.219 6.219 0 0 0 1.187-1.765c.05-.218.193-.4.388-.494a.68.68 0 0 1 .613.012c.351-.316.733-.592 1.141-.823.56-.3 1.21.302 1.21.302l.07 2.225s.055.073.145.202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M189.65 72.841c.23.526.295 2.469.295 2.469l-.644.69-1.223-4.75-.055-2.469-.023-.14.018.028c.094-.701.412-1.312.87-1.669l.833 1.495.279 1.794s-.076.252-.556.75c-.48.497.205 1.802.205 1.802z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCD2E0",
    fillOpacity: 0.118,
    fillRule: "nonzero",
    d: "M189.65 72.833c.23.525.297 2.468.297 2.468l-.644.699-1.222-4.749-.056-2.467-.025-.14.018.028c.094-.702.412-1.313.87-1.672l.833 1.498.279 1.793s-.076.252-.556.75c-.48.496.205 1.792.205 1.792z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M201 65.503A6.5 6.5 0 1 1 194.5 59a6.446 6.446 0 0 1 6.5 6.503z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6BAC2",
    fillRule: "nonzero",
    d: "M199.989 61.84c.001 2.79-.768 7.361-3.26 8.43-2.492 1.068-3.692 2.44-6.663 1.302-2.97-1.137-2.158-7.945-1.125-10.523 1.033-2.577 2.54-4.05 5.238-4.049a6.518 6.518 0 0 1 4.724 2.008c1.252 1.295 1.096 1 1.086 2.832z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M202 64.066a7.11 7.11 0 0 1-1.01 3.667c-.102-.186-.163-.401-.265-.59-.144-.264-.477-.486-.724-.326a.753.753 0 0 0-.227.326c-.202.433-.561.867-1.032.857a1.027 1.027 0 0 1-.878-.763 3.186 3.186 0 0 1-.051-1.245c.07-.847.083-1.825-.535-2.396a3.476 3.476 0 0 0-1.34-.61c-.47-.156-.96-.403-1.152-.866-.129-.326-.097-.672-.212-.978a1.685 1.685 0 0 0-1.246-.932 3.232 3.232 0 0 1-2.182.76 8.047 8.047 0 0 1-2.146-.346c1.538-2.808 4.746-4.204 7.804-3.397 3.058.807 5.194 3.614 5.196 6.829v.01z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7E646B",
    fillRule: "nonzero",
    d: "M193.46 60.666c.112.34.081.708.205 1.021.182.484.658.743 1.112.906.467.11.907.325 1.292.633.597.6.584 1.621.516 2.507-.062.432-.046.875.05 1.3.107.432.443.747.847.797.454 0 .8-.443.995-.895a.797.797 0 0 1 .22-.341c.237-.174.559.058.698.34.097.295.231.574.398.828a.83.83 0 0 0 .813.204c.28-.084.54-.232.764-.436a4.536 4.536 0 0 0 1.421-1.883 2.95 2.95 0 0 0-.09-2.383c-.231-.43-.599-.773-.744-1.246-.254-.814.222-1.652.516-2.449.281-.728.372-1.529.263-2.312-.116-.787-.513-1.49-1.104-1.95-1.174-.862-2.763-.389-4.123-.804a9.936 9.936 0 0 1-1.418-.644 9.828 9.828 0 0 0-2.163-.763c-.74-.163-1.632-.183-2.099.467a5.312 5.312 0 0 0-.34.654c-.294.544-.776.934-1.335 1.082-.399.106-.816.079-1.236.144a1.34 1.34 0 0 0-1.03.65c-.203.408-.117.906-.067 1.362.05.456.024 1.001-.31 1.284-.157.132-.373.197-.47.384-.09.226-.03.491.146.644.174.145.376.243.59.286a8.281 8.281 0 0 0 2.37.446c.814.03 1.606-.292 2.207-.896-.052.058-.392.035-.454.031.6.072 1.335.364 1.56 1.032z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.516 66.742a2.31 2.31 0 0 1-.808.384c-.3.07-.62.003-.856-.181a2.826 2.826 0 0 1-.425-.723c-.147-.24-.487-.443-.74-.297a.734.734 0 0 0-.231.297c-.203.396-.572.791-1.053.782-.427-.041-.782-.318-.892-.696a2.605 2.605 0 0 1-.056-1.135c.075-.773.085-1.662-.543-2.185a3.78 3.78 0 0 0-1.37-.556c-.477-.143-.98-.369-1.176-.791-.131-.297-.099-.613-.216-.892-.193-.473-.739-.731-1.272-.85a3.614 3.614 0 0 1-2.226.695 10.576 10.576 0 0 1-2.508-.392 1.594 1.594 0 0 1-.624-.247.648.648 0 0 1-.102-.107.909.909 0 0 0-.366.259.446.446 0 0 0 .154.562c.184.126.398.212.624.25.813.23 1.657.361 2.508.389a3.582 3.582 0 0 0 2.223-.693c.533.12 1.082.375 1.275.847.118.298.085.619.216.892.196.422.696.648 1.177.791a3.78 3.78 0 0 1 1.366.553c.631.523.618 1.415.546 2.188-.066.378-.048.764.052 1.136.114.377.47.652.896.696.48 0 .847-.387 1.053-.782a.698.698 0 0 1 .232-.298c.252-.151.592.05.739.298.103.258.246.501.425.722.235.185.556.252.856.178a2.25 2.25 0 0 0 .808-.38 4.142 4.142 0 0 0 1.504-1.644c.058-.127.105-.259.14-.393a4.42 4.42 0 0 1-1.33 1.323zM204.17 60.91c.068-.137.134-.274.196-.408.062-.134.085-.208.12-.315a6.67 6.67 0 0 0-.316.722zM188.883 59.04c.327-.253.35-.705.297-1.095a4.43 4.43 0 0 1-.062-.686c-.07.062-.13.132-.18.208-.215.357-.124.79-.072 1.189.017.127.023.255.017.383z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M189 104.849a71.01 71.01 0 0 1-4.56.151c-.7 0-1.44 0-2.209-.033a48.15 48.15 0 0 1-7.242-.734c-3.193-.605-6.145-1.647-7.989-3.411.307-.586.587-1.073.691-1.245 0-.17 0-.366-.018-.577 3.242 1.51 13.347 5.707 21.093 3.323 0 .251.037.417.037.417l.175.145c-.089.314-.033 1.348.022 1.964z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B4442",
    fillRule: "nonzero",
    d: "M189 104.852c-.572.04-1.373.082-2.338.112-.67.024-1.42.036-2.222.036-.7 0-1.44 0-2.209-.033-2.43-.06-4.85-.305-7.242-.731-3.193-.605-6.145-1.65-7.989-3.414.307-.586.587-1.07.691-1.245 0-.17 0-.362-.018-.577 3.242 1.51 13.347 5.71 21.093 3.338 0 .251.037.417.037.417l.175.145c-.089.302-.033 1.336.022 1.952z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "nonzero",
    d: "M32.003 244a4.32 4.32 0 0 1-.97-3.297l13.95-113.742 1.157-9.448a4.372 4.372 0 0 1 4.31-3.83l40.862-.27a4.378 4.378 0 0 0 3.115-1.328 4.347 4.347 0 0 0 1.227-3.147l-.016-.431a4.35 4.35 0 0 1 1.227-3.177 4.38 4.38 0 0 1 3.144-1.33h42.938a4.363 4.363 0 0 1 4.333 4.932 4.345 4.345 0 0 0 1.007 3.404 4.377 4.377 0 0 0 3.215 1.527l41.238 1.05a4.373 4.373 0 0 1 3.267 1.587 4.341 4.341 0 0 1 .93 3.501L176.32 239.988l-.389 2.267a4.252 4.252 0 0 1-.632 1.625L32.003 244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    fillRule: "nonzero",
    d: "M-7.077 29.65l83.212-.126-.038 25.413-83.213.126z",
    opacity: 0.5,
    transform: "rotate(-55.36 161.903 -22.148)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    fillRule: "nonzero",
    d: "M156.323 79l19.836 13.74-46.514 67.494-19.836-13.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA853",
    fillRule: "nonzero",
    d: "M157.752 82.198l13.976 9.74-9.715 14.011-13.976-9.74z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA853",
    fillRule: "nonzero",
    d: "M146.804 99.083l14.022 9.713-9.688 14.058-14.023-9.713z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7B643",
    fillRule: "nonzero",
    d: "M135.104 116.056l14.023 9.712-9.688 14.058-14.023-9.712z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillRule: "nonzero",
    d: "M-17.401 30.941l82.797-.145-.044 25.271-82.798.145z",
    opacity: 0.5,
    transform: "rotate(-73.71 125.835 10.466)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    fillRule: "nonzero",
    d: "M128.297 74.773l23.142 6.78-22.867 78.445-23.141-6.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED6B6B",
    fillRule: "nonzero",
    d: "M131.336 77.038l16.36 4.793-4.782 16.4-16.36-4.792z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED6B6B",
    fillRule: "nonzero",
    d: "M125.563 96.838l16.36 4.793-4.781 16.4-16.36-4.792z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F97878",
    fillRule: "nonzero",
    d: "M119.791 116.635l16.36 4.793-4.78 16.4-16.36-4.792z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillRule: "nonzero",
    d: "M-25.342 30.08l82.733-.092-.029 25.038-82.733.093z",
    opacity: 0.5,
    transform: "rotate(-85.4 109.19 24.201)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    fillRule: "nonzero",
    d: "M111.905 76.01l24.032 1.939-6.538 81.463-24.032-1.939z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1D659",
    fillRule: "nonzero",
    d: "M115.325 77.612l16.99 1.37-1.368 17.032-16.989-1.37z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1D659",
    fillRule: "nonzero",
    d: "M113.673 98.17l16.99 1.37-1.368 17.032-16.989-1.37z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#73B53B",
    fillRule: "nonzero",
    d: "M112.024 118.734l16.989 1.37-1.367 17.032-16.989-1.37z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    fillRule: "nonzero",
    d: "M2.036.846l25.059-.01-.033 82.378-25.06.01z",
    opacity: 0.5,
    transform: "rotate(-2.61 1754.592 -2114.33)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M101.093 79.286l24.085-1.101 3.712 81.641-24.084 1.101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3247C",
    fillRule: "nonzero",
    d: "M104.684 80.44l17.026-.778.776 17.069-17.026.778z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3247C",
    fillRule: "nonzero",
    d: "M106.288 100.393l17.044-.854.852 17.087-17.044.854z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3247C",
    fillRule: "nonzero",
    d: "M106.557 121.654l17.026-.778.776 17.07-17.026.777z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6ECF8",
    fillRule: "nonzero",
    d: "M112 186.659l-21.552 8.267L58.95 207c-1.191-2.204-2.944-5.182-5.112-8.736-7.461-12.26-19.806-31.329-30.797-48.087C10.658 131.287 0 115.347 0 115.347l7.715-2.203L70.738 95 112 186.659z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M112 187.278L90.507 195.6a161.394 161.394 0 0 1-36.522 3.36c-7.44-12.343-19.751-31.54-30.714-48.412L8 113.253 70.85 95 112 187.278z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCD2E0",
    fillRule: "nonzero",
    d: "M128 181.077s-33.394 19.728-83.253 15.266L5 99.564l19.049-3.27L89.899 85l37.37 94.195.731 1.882z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M127 180.778c-7.771.385-16.763.347-25.808-.74-9.79-1.158-19.637-3.545-28.078-7.922-7.057-3.655-13.092-7.632-18.353-12.403C41.075 147.33 32.605 129.615 25 98.244L90.08 87 127 180.778z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    fillRule: "nonzero",
    d: "M151 174.18s-24.583 4.823-49.606 1.854c-9.893-1.166-19.843-3.568-28.373-7.972-7.131-3.678-13.226-7.68-18.545-12.48C37.359 140.153 28.32 116.51 19 68.764c0 0 40.868 9.882 81.28-11.765-.012.016 13.61 85.179 50.72 117.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M101 175c-9.7-1.142-19.454-3.493-27.817-7.805-6.992-3.602-12.967-7.52-18.183-12.22C69.288 153.815 71.341 146 71.341 146 81.933 162.817 101 175 101 175z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCD2E0",
    fillRule: "nonzero",
    d: "M40 87.467S73.294 85.5 82.59 78L84 82.735S62.002 92.877 40 93v-5.533zM40 108.43S72.003 106.678 96.182 95L97 96.868S77.812 108.068 40 111v-2.57zM43 118.43s32.004-1.752 56.182-13.43l.818 1.868S80.811 118.065 43 121v-2.57zM45 126.43s32.004-1.752 56.185-13.43l.815 1.868S82.811 126.068 45 129v-2.57zM48 135.43s32.004-1.752 56.182-13.43l.818 1.868S85.811 135.068 48 138v-2.57zM51 143.43s32.004-1.752 56.185-13.43l.815 1.868S88.811 143.065 51 146v-2.57z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.5,
    cy: 258,
    fill: "#B3247C",
    fillRule: "nonzero",
    opacity: 0.1,
    rx: 32.5,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    fillRule: "nonzero",
    d: "M220.578-7.463l53.981-.04-.071 96.404-53.98.04z",
    transform: "rotate(-71.99 247.533 40.72)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7F9",
    fillRule: "nonzero",
    d: "M194.125 51.31L210.548.67l90.392 29.46-16.423 50.642z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.482,
    cy: 9.959,
    fill: "#B3247C",
    fillRule: "nonzero",
    opacity: 0.2,
    rx: 9.31,
    ry: 9.956,
    transform: "translate(211 19)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3247C",
    fillRule: "nonzero",
    d: "M243.312 26.796l.852-2.618 41.696 13.54-.853 2.618zM241.063 32.759l.834-2.635 20.803 6.941-.835 2.635zM238.367 40.861l.856-2.785 34.495 11.866-.855 2.784zM237.207 46.29l.853-2.618 41.695 13.54-.852 2.618z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3247C",
    fillRule: "nonzero",
    d: "M263.114 68.086l1.59-4.66 11.13 3.45-1.59 4.66z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    fillRule: "nonzero",
    d: "M239.993 153.303a2.894 2.894 0 0 0-.032-.317c0-.111-.035-.223-.054-.318a12.399 12.399 0 0 0-.137-.635c-.025-.098-.05-.2-.08-.295a8.042 8.042 0 0 0-1.59-3.069c-.042-.05-.087-.098-.128-.146a7.758 7.758 0 0 0-.506-.505 10.55 10.55 0 0 0-.235-.203 8.693 8.693 0 0 0-.42-.317c-.124-.09-.182-.12-.258-.165a1.415 1.415 0 0 0-.598-.194l-1.32-.13-1.805-.178-6.45-2.498-.255.09c-.189-.52-.348-1.05-.477-1.588.195-.084.37-.211.509-.371.152-.118.272-.272.35-.448.162-.374-.15-1.171-.086-1.628.102-.733.484-1.441.796-2.104.662-1.426 1.145-2.971 1.066-4.536-.08-1.565-.796-3.152-2.12-4.025-.684-.454-1.489-.695-2.202-1.108-.553-.317-1.04-.742-1.568-1.104a9.038 9.038 0 0 0-8.885-.635c-1.34.657-2.482 1.641-3.745 2.431s-2.753 1.397-4.232 1.162a1.03 1.03 0 0 0-.045.184l-.124-.016c-.254.692.37 1.378.955 1.85 1.091.899 2.329 1.794 3.751 1.826.55 0 1.133-.105 1.633.12.113.05.22.114.318.19a7.06 7.06 0 0 0 2.227 7.05l-3.293-1.18s-.137.07-.35.203l-4.57-3.035s-9.16-3.313-11.706 1.848c-2.546 5.16 11.032 2.498 11.032 2.498l2.905 1.587a2.632 2.632 0 0 0 .318 1.74l7.92 4.88c-1.59.493-4.228 1.27-4.696 1.27-.678 0-2.546.667-3.733 3.33-1.187 2.663-5.432 15.654-9.164 17.819-3.733 2.165-13.575 16.654-13.575 16.654l.045.114a8.81 8.81 0 0 0-.516.153 10.428 10.428 0 0 0-5.114 3.847 1.628 1.628 0 0 0-.167 1.614c.236.53.736.895 1.313.96 3.885.492 6.008-1.295 7.03-2.644.066-.086.127-.172.184-.257.302.13.641.145.954.044l4.751-3.831s-3.716 3.65-1.537 6.983l-.165.232a52.915 52.915 0 0 0-7.955 17.273s-2.037 1.498-2.206 7.494c-.168 5.995-2.208 15.654-2.208 15.654s-1.355 11.493-.509 14.988c0 0 .099.14.28.352a6.274 6.274 0 0 1-.21.241c-.741.8-2.078 1.905-3.634 1.587-2.374-.501-2.374 3.663 1.018 3.996 2.186.213 6.482 1.187 9.267 1.854a1.954 1.954 0 0 0 1.749-.412c.481-.413.73-1.034.669-1.664-.166-1.492-.468-3.298-1.018-4.583a8.23 8.23 0 0 0-.105-.232c.098-.095.2-.19.299-.292 0 0 0-7.329 1.19-9.325 0 0 3.223-15.156 3.051-18.987-.13-2.997 8.366-14.667 12.064-19.597l-.032-.187c.955-1.27 1.546-2.031 1.546-2.031l2.861 18.155s1.359 3.996 3.055 6.16c0 0 7.296 13.824 8.146 18.153.637 3.285 1.967 5.225 2.571 5.974l-.22.21c-.773.707-1.909 1.415-3.2 1.145-2.374-.502-2.374 3.663 1.018 3.996 2.186.216 6.482 1.19 9.263 1.857.616.155 1.27 0 1.751-.413a1.946 1.946 0 0 0 .67-1.666c-.194-1.733-.572-3.888-1.304-5.161a3.569 3.569 0 0 0-.194-.317c.258-.104.49-.266.674-.473 0 0-4.413-10.494-4.413-13.331 0 0-1.865-10.824-8.143-14.82 0 0 .592-13.54 2.38-21.075.044-.185.089-.369.134-.546 1.666-.26 3.319-.603 4.95-1.029l.17-4.996.85 3.996 9.5-5.827s-.082-1.05-.241-2.66c-.083-.806-.181-1.752-.3-2.777-.095-.82-.203-1.689-.317-2.578-.032-.222-.06-.447-.093-.67-.124-.897-.26-1.805-.407-2.694a70.672 70.672 0 0 0-.414-2.26c-.041-.206-.086-.413-.127-.612-.041-.2-.089-.4-.134-.594-.044-.194-.089-.38-.133-.568-.026-.092-.048-.184-.07-.273l-.143-.53a9.5 9.5 0 0 1-.344-2.184v-.88c0-.291.045-.583.086-.875a6.79 6.79 0 0 1 .073-.432 9.671 9.671 0 0 1 .837-2.52c.318-.635.636-1.31.974-2.031.172-.36.343-.727.515-1.102.172-.374.347-.755.522-1.142 1.652-3.673 3.28-7.764 3.717-10.453.044-.282.08-.549.095-.8a5.09 5.09 0 0 0 .01-.685z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE6E79",
    fillRule: "nonzero",
    d: "M211 143.143l-5.512-4.03s-8.753-3.507-11.184 1.929c-2.432 5.436 10.535 2.63 10.535 2.63l5.512 3.328.649-3.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    fillRule: "nonzero",
    d: "M150.887 174.178l28.71-44.772 69.525 44.807-28.71 44.772z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    fillRule: "nonzero",
    d: "M159.186 163.89l15.048-.017-.004 3.537-15.048.017z",
    opacity: 0.466,
    transform: "rotate(-57.57 166.708 165.65)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    fillRule: "nonzero",
    d: "M164.415 158.941l33.05-.037-.005 3.243-33.048.037z",
    opacity: 0.466,
    transform: "rotate(-57.57 180.938 160.544)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    fillRule: "nonzero",
    d: "M170.259 162.66l33.049-.038-.004 3.244-33.049.037z",
    opacity: 0.466,
    transform: "rotate(-57.57 186.781 164.263)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    fillRule: "nonzero",
    d: "M176.1 166.385l33.05-.038-.004 3.243-33.049.038z",
    opacity: 0.466,
    transform: "rotate(-57.57 192.623 167.987)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    fillRule: "nonzero",
    d: "M182.225 171.857l33.002-.038-.004 3.239-33.002.037z",
    opacity: 0.466,
    transform: "rotate(-57.265 198.724 173.457)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M194.095 188.516l17.691-27.915 2.736 1.742-17.691 27.915zM199.939 192.234l17.691-27.915 2.735 1.743-17.69 27.915z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7B6CC",
    fillRule: "nonzero",
    d: "M224.471 176.377l4.581-7.228 7.21 4.592-4.58 7.229z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBED0",
    fillRule: "nonzero",
    d: "M227.473 257.946c-2.906-.685-7.386-1.685-9.666-1.906-3.542-.331-3.542-4.635-1.061-4.112 1.342.281 2.533-.45 3.337-1.175a7.66 7.66 0 0 0 .685-.725 2.066 2.066 0 0 1 1.146-.679c1.328-.278 4.107-.702 5.788.182.393.236.71.573.917.974.763 1.324 1.16 3.525 1.37 5.296a1.953 1.953 0 0 1-.685 1.703c-.5.426-1.183.591-1.831.442zM186.465 259.944c-2.901-.686-7.38-1.687-9.658-1.909-3.542-.331-3.542-4.64-1.064-4.114 1.621.332 3.017-.799 3.787-1.62.096-.1.181-.196.253-.286a2.066 2.066 0 0 1 1.143-.663c1.328-.282 4.106-.706 5.79.182.499.259.896.83 1.214 1.568.571 1.326.886 3.183 1.06 4.718a1.958 1.958 0 0 1-.697 1.693 2.101 2.101 0 0 1-1.828.431z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M187 253.132c-3.521 4.306-6.54-.081-7-.805.08-.102.151-.2.211-.291.245-.345.58-.583.952-.677 1.107-.287 3.422-.72 4.825.186.416.25.761.833 1.012 1.587zM228 250.23c-1.499.987-6.543.743-6.543.743a4.607 4.607 0 0 1-.457-.54c.2-.186.387-.384.56-.593.24-.281.57-.477.939-.555 1.086-.227 3.36-.573 4.736.15.327.19.592.466.765.795z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCD2E0",
    fillRule: "nonzero",
    d: "M229 249.762c-1.16 1.469-7.765 1.14-7.765 1.14s-1.983-1.957-2.81-6.193c-.828-4.237-7.931-17.773-7.931-17.773-1.652-2.122-2.974-6.034-2.974-6.034l-2.807-17.772s-13.546 17.609-13.38 21.36c.166 3.751-2.977 18.598-2.977 18.598-1.156 1.958-1.156 9.142-1.156 9.142-4.293 4.413-7.928-.816-7.928-.816-.827-3.424.495-14.674.495-14.674s1.984-9.457 2.147-15.327c.163-5.87 2.15-7.335 2.15-7.335a51.962 51.962 0 0 1 7.758-16.916c.996-1.409 1.657-2.162 1.657-2.162l26.763 3.099a16.478 16.478 0 0 0-1.15 3.499c-1.74 7.376-2.319 20.632-2.319 20.632 6.114 3.912 7.931 14.5 7.931 14.5 0 2.758 4.296 13.032 4.296 13.032z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.363 204.618l-.34-2.199s-13.362 17.828-13.199 21.626c.164 3.798-2.933 18.83-2.933 18.83-1.144 1.981-1.144 9.255-1.144 9.255a5.563 5.563 0 0 1-2.549 1.656c1.283.342 2.836.09 4.506-1.656 0 0 0-7.264 1.14-9.256 0 0 3.098-15.022 2.934-18.83-.126-2.97 8.03-14.543 11.585-19.426z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.696 236.424s-1.793-10.73-7.82-14.68c0 0 .57-13.42 2.284-20.889.249-1.22.63-2.408 1.138-3.542l-26.4-3.131s-.063.07-.176.21l24.62 2.927a16.993 16.993 0 0 0-1.135 3.543c-1.717 7.468-2.287 20.888-2.287 20.888 6.03 3.96 7.823 14.68 7.823 14.68 0 2.806 4.237 13.207 4.237 13.207-.674.875-3.213 1.12-5.189 1.175 1.576.041 6.198.057 7.143-1.175 0-.006-4.238-10.407-4.238-13.213z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AE6E79",
    fillRule: "nonzero",
    d: "M189 192.868c-.2.496-.46.962-.779 1.388-.988 1.358-3.045 3.153-6.809 2.66a1.622 1.622 0 0 1-1.276-.974 1.677 1.677 0 0 1 .164-1.618 10.159 10.159 0 0 1 4.955-3.89 8.894 8.894 0 0 1 2.102-.434l1.643 2.868z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D86A1",
    fillRule: "nonzero",
    d: "M224 146.887L210.674 142s-3.823 2-2.326 4.833L221.324 155l2.676-8.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE6E79",
    fillRule: "nonzero",
    d: "M224.12 139.329s-.167 7.835 3.31 10.504c3.477 2.668-10.095 4.167-10.095 4.167s2.152-8.003 0-12.17c-2.153-4.167 6.784-2.501 6.784-2.501z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M220 198.043a16.141 16.141 0 0 0-1.133 3.435c-15.734 2.365-26.7-4.076-26.7-4.076a4.339 4.339 0 0 1-.167-.279c.982-1.383 1.633-2.123 1.633-2.123L220 198.043zM189 192.691a5.663 5.663 0 0 1-.832 1.309c-1.626-.245-2.927-3.058-3.168-3.59.727-.216 1.48-.354 2.244-.41l1.756 2.691z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D86A1",
    fillRule: "nonzero",
    d: "M224.041 145l-5.808 2.135-2.42 3.29s-4.99 1.642-5.645 1.642c-.655 0-2.42.658-3.55 3.286-1.129 2.628-5.162 15.456-8.711 17.588-3.55 2.132-12.907 16.435-12.907 16.435s1.613 4.448 3.55 3.781l4.516-3.781s-3.55 3.616-1.454 6.905c0 0 13.231 8.052 31.462 3.12l.16-4.928.807 3.943 9.045-5.751s-.807-10.61-2.264-16.01a9.93 9.93 0 0 1 .624-6.803c2.342-4.973 5.957-13.279 5.517-16.307-.52-3.569-2.495-5.12-3.256-5.587a1.33 1.33 0 0 0-.568-.193l-2.953-.3L224.04 145z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M216 162s-3.361 15.065-7.057 17.496c-3.696 2.43-13.605 10.207-13.943 11.504",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M217 151s11.638-5.11 15-3.779",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.887 170.105c2.56-5 6.512-13.353 6.031-16.398-.57-3.588-2.727-5.147-3.559-5.617a1.54 1.54 0 0 0-.62-.195l-1.364-.128c.145.031.283.084.41.157.824.473 2.989 2.029 3.555 5.62.48 3.042-3.47 11.398-6.028 16.398a9.25 9.25 0 0 0-.681 6.838c1.595 5.432 2.478 16.098 2.478 16.098l-8.502 4.981.215.959 9.886-5.784s-.883-10.669-2.475-16.097a9.255 9.255 0 0 1 .654-6.832zM229.925 147.425l1.527.144-6.64-2.457-.597.201z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M213 178s5.272-2.428 6.99-1.856c1.716.571 8.01-.144 8.01-.144M223.43 140.614c-.185-1.545.57-1.31.57-1.31s-8.786-1.54-6.672 2.31a8.442 8.442 0 0 1 .894 3.386h.085c2.44.003 3.865-2.582 5.124-4.386z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 137.5,
    r: 7.5,
    fill: "#AE6E79",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M225.964 140.375c.633-1.437 1.104-2.993 1.028-4.569-.076-1.575-.765-3.174-2.043-4.055-.658-.454-1.436-.697-2.123-1.112-.534-.325-1.005-.75-1.515-1.112a8.397 8.397 0 0 0-8.565-.649c-1.29.649-2.391 1.657-3.609 2.451s-2.654 1.404-4.08 1.17c-.247.698.357 1.385.91 1.865 1.054.904 2.246 1.806 3.62 1.835.53 0 1.09-.104 1.58.123.325.184.601.446.804.765.66.9 1.22 1.874 1.67 2.902.138.442.397.834.747 1.128.632.415 1.451.068 2.214.039 1.164-.049 2.214.703 3.074 1.507.86.804 1.683 1.725 2.77 2.15.814.324 2.44.305 2.847-.69.155-.377-.145-1.18-.082-1.641a8.064 8.064 0 0 1 .753-2.107z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42383C",
    fillRule: "nonzero",
    d: "M225.963 139.377c.633-1.437 1.107-2.993 1.028-4.566-.079-1.573-.762-3.178-2.04-4.056-.661-.458-1.44-.7-2.123-1.116-.534-.324-1.005-.746-1.515-1.112a8.398 8.398 0 0 0-8.566-.649c-1.29.649-2.391 1.654-3.61 2.449-1.217.794-2.653 1.407-4.08 1.17-.247.7.354 1.388.911 1.865 1.053.904 2.246 1.806 3.619 1.838.531 0 1.091-.107 1.581.124.327.182.603.445.804.765.66.899 1.22 1.871 1.667 2.899.139.442.4.834.75 1.128.632.415 1.452.068 2.214.04 1.164-.046 2.214.706 3.072 1.51.857.804 1.683 1.722 2.774 2.147.813.324 2.439.305 2.847-.69.158-.377-.143-1.181-.08-1.642a8.06 8.06 0 0 1 .747-2.104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F313D",
    fillRule: "nonzero",
    d: "M175.773 243.255a3.263 3.263 0 0 1-2.1.745l-141.667-.605a4.385 4.385 0 0 1-.973-3.33l13.996-114.907 8.777-.095a3.318 3.318 0 0 1 3.235 2.456l1.64 6.07a3.318 3.318 0 0 0 3.278 2.456l35.03-.843a3.323 3.323 0 0 0 3.237-3.328v-4.021a3.322 3.322 0 0 1 3.278-3.328l48.54-.525a3.32 3.32 0 0 1 3.29 2.701L176.8 239.326l.14.726a3.315 3.315 0 0 1-1.167 3.203z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    fillRule: "nonzero",
    d: "M150.09 127l-48.466.525a3.32 3.32 0 0 0-3.277 3.325v4.024a3.32 3.32 0 0 1-3.23 3.324l-34.972.844a3.31 3.31 0 0 1-3.277-2.456l-1.643-6.067a3.311 3.311 0 0 0-3.233-2.456l-46.716.506a3.302 3.302 0 0 0-2.506 1.192 3.336 3.336 0 0 0-.723 2.689L20.84 243.593a3.316 3.316 0 0 0 3.251 2.77l147.585.637a3.305 3.305 0 0 0 2.56-1.202 3.34 3.34 0 0 0 .704-2.75l-21.567-113.347A3.313 3.313 0 0 0 150.09 127z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6BAC2",
    fillRule: "nonzero",
    d: "M217.885 50.827l-.256 2.826.186 5-.541 8.432s-.077 3.694-2.179 5.425l-5.364 8.178-.032.016-2.019.978-3.08.318-1.6-3.846 1.059-4.224.588-.788.164-.178c.64-.699 3.11-3.236 5.07-4.027 0 0 1.308-.953 1.078-2.446-.23-1.493 1.766-9.427 1.766-9.427s1.28-5.246 1.001-5.758c-.278-.511-.051-12.126 4.364-12.304 4.414-.178-.205 11.825-.205 11.825z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7F9",
    fillRule: "nonzero",
    d: "M79.474 186.187l-.354-.444a.539.539 0 0 1-.12-.346c0-.132.043-.258.12-.347l3.105-3.9a.348.348 0 0 1 .276-.15c.105 0 .205.054.277.15l3.105 3.896c.075.091.117.216.117.347 0 .13-.042.256-.117.347l-.354.444a.352.352 0 0 1-.277.147.352.352 0 0 1-.276-.147l-1.836-2.428v5.762c0 .127-.04.25-.11.34a.348.348 0 0 1-.272.142h-.511c-.212 0-.384-.216-.384-.482v-5.755l-1.836 2.428a.35.35 0 0 1-.277.146.353.353 0 0 1-.276-.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7F9",
    fillRule: "nonzero",
    d: "M83 178.93a7.07 7.07 0 1 1-7.07 7.07 7.076 7.076 0 0 1 7.07-7.07zm0-.93a8 8 0 1 0 0 16 8 8 0 0 0 0-16z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotFilesFound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notFilesFound.7d71d480.svg";
export { ForwardRef as ReactComponent };